"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.utmSourceTable = void 0;
const helpers_1 = require("../../../helpers");
const utmSourceTable = (dateRange, filters) => ({
    queries: [
        {
            measures: ['Attribution.cost'],
            dimensions: ['Attribution.utmSource'],
            filters: filters ? (0, helpers_1.filterFilters)(filters, 'Attribution.') : [],
            limit: 10000,
            timeDimensions: [
                {
                    dimension: 'Attribution.date',
                    dateRange,
                },
            ],
        },
        {
            measures: ['Conversions.count'],
            dimensions: ['Attribution.utmSource'],
            filters: filters ? (0, helpers_1.filterFilters)(filters, 'Conversions.') : [],
            limit: 10000,
            timeDimensions: [
                {
                    dimension: 'Attribution.date',
                    dateRange,
                },
            ],
        },
    ],
    resultProcessor: rows => {
        const conversionsInfoMap = rows[1]
            .tablePivot()
            .map(row => {
            const [utmSource, count] = Object.values(row);
            return {
                utmSource,
                count,
            };
        })
            .reduce((map, conversion) => {
            const conversionsList = map.get(conversion.utmSource) || [];
            conversionsList.push(conversion);
            map.set(conversion.utmSource, conversionsList);
            return map;
        }, new Map());
        const attributions = rows[0].tablePivot().map(row => {
            const [utmSource, cost] = Object.values(row);
            const conversionsInfo = (conversionsInfoMap.get(utmSource) || []).reduce((res, conversionInfo) => {
                res.count += conversionInfo.count;
                return res;
            }, { count: 0 });
            return {
                utmSource,
                conversions: conversionsInfo.count,
                CPA: conversionsInfo.count > 0 ? cost / conversionsInfo.count : 0,
                cost,
            };
        });
        return {
            lastRefreshTime: new Date(Math.max(...rows.flatMap(row => row
                .serialize()
                .loadResponse.results.map(result => new Date(result.lastRefreshTime).valueOf())))),
            tableColumns: () => [
                ...['utmSource'].map(key => ({
                    key: key || '-',
                    title: key || '-',
                    shortTitle: key || '-',
                    type: 'string',
                    dataIndex: key || '-',
                    meta: '',
                })),
                ...['conversions', 'CPA', 'cost'].map(key => ({
                    key,
                    title: key,
                    shortTitle: key,
                    type: 'number',
                    dataIndex: key,
                    meta: '',
                })),
            ],
            tablePivot: () => attributions,
        };
    },
});
exports.utmSourceTable = utmSourceTable;
//# sourceMappingURL=utmSource.js.map